module.exports = __webpack_public_path__ + "static/Juxtapose-Sign-Up-Form-bbd2f5c04a25aff90bd703ea4eb921c1.png";